import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-html-template-editor',
  standalone: false,
  templateUrl: './html-template-editor.component.html',
  styleUrl: './html-template-editor.component.scss'
})
export class HtmlTemplateEditorComponent {

  @Input() html = '';
  @Output() htmlChange = new EventEmitter<string>();
}
